import Distributor from './distributor'

export default Distributor
